import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Wallet from "../../components/User/Wallet";

export default withRouter(connect()(Wallet));
